/* Al Fagr — custom homepage sections (vanilla JS, RTL aware) */
(function () {
  'use strict';

  var rtl = function (el) { return getComputedStyle(el).direction === 'rtl'; };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- scroll carousel with arrows ---------- */
  function initCarousel(root) {
    if (root.__fgc) return; root.__fgc = true;
    var track = root.querySelector('[data-track]');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (!track) return;
    function step() {
      var c = track.children[0];
      if (!c) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var ratio = parseFloat(root.getAttribute('data-step-ratio') || '0');
      if (ratio > 0) return track.clientWidth * ratio;
      var per = parseInt(root.getAttribute('data-step') || '1', 10);
      return (c.getBoundingClientRect().width + gap) * per;
    }
    function go(dir) {
      track.scrollBy({ left: dir * step() * (rtl(track) ? -1 : 1), behavior: 'smooth' });
    }
    function update() {
      var sl = Math.abs(track.scrollLeft);
      var max = track.scrollWidth - track.clientWidth;
      var overflow = max > 6;
      root.classList.toggle('is-overflow', overflow);
      if (prev) prev.disabled = !overflow || sl < 10;
      if (next) next.disabled = !overflow || sl > max - 10;
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 500);
    // keep the current page link visible in the category strip
    var cur = track.querySelector('.is-current');
    if (cur && root.hasAttribute('data-reveal-current')) {
      var tb = track.getBoundingClientRect(), cb = cur.getBoundingClientRect();
      track.scrollLeft += cb.left - tb.left - tb.width / 2 + cb.width / 2;
    }
  }

  /* ---------- centre-focus carousel ---------- */
  function initFocus(root) {
    if (root.__fgf) return; root.__fgf = true;
    var stage = root.querySelector('[data-stage]');
    var track = root.querySelector('[data-track]');
    var slides = $$('[data-fslide]', track);
    var dots = $$('[data-dot]', root);
    if (!slides.length) return;
    var idx = Math.max(0, Math.min(parseInt(root.getAttribute('data-start') || '0', 10), slides.length - 1));
    var timer = null;
    function layout() {
      var w = slides[0].offsetWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var off = stage.clientWidth / 2 - (idx * (w + gap) + w / 2);
      track.style.transform = 'translateX(' + off + 'px)';
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === idx);
        s.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
        s.tabIndex = i === idx ? 0 : -1;
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
        d.setAttribute('aria-current', i === idx ? 'true' : 'false');
      });
    }
    function go(i) { idx = (i + slides.length) % slides.length; layout(); }
    slides.forEach(function (s, i) {
      s.addEventListener('click', function (e) { if (i !== idx) { e.preventDefault(); go(i); restart(); } });
    });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); restart(); }); });
    var sx = null;
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 40) { go(idx + (dx < 0 ? 1 : -1)); restart(); }
    });
    function restart() {
      clearInterval(timer);
      var sec = parseFloat(root.getAttribute('data-autoplay') || '0');
      if (sec > 0) timer = setInterval(function () { go(idx + 1); }, sec * 1000);
    }
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    window.addEventListener('resize', layout);
    layout();
    window.requestAnimationFrame(function () { root.classList.add('is-ready'); });
    restart();
  }

  /* ---------- cross-fade slider (looks + curated) ---------- */
  function initSlides(root) {
    if (root.__fgs) return; root.__fgs = true;
    var slides = $$('[data-slide]', root);
    var mirrors = $$('[data-mirror]', root);
    var dots = $$('[data-dot]', root);
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var cur = root.querySelector('[data-current]');
    var idx = 0;
    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) {
        s.classList.toggle('is-active', j === idx);
        s.setAttribute('aria-hidden', j === idx ? 'false' : 'true');
        if ('inert' in s) s.inert = j !== idx;
      });
      mirrors.forEach(function (m) {
        var on = parseInt(m.getAttribute('data-mirror'), 10) === idx;
        m.classList.toggle('is-active', on);
        m.setAttribute('aria-hidden', on ? 'false' : 'true');
        if ('inert' in m) m.inert = !on;
      });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === idx); });
      if (cur) cur.textContent = ('0' + (idx + 1)).slice(-2);
      root.dispatchEvent(new CustomEvent('fg:slide', { detail: { index: idx, slide: slides[idx] } }));
    }
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { show(j); }); });
    var sx = null;
    root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (sx === null || slides.length < 2) return;
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 60) show(idx + ((dx < 0) !== rtl(root) ? 1 : -1));
    });
    if (slides.length < 2) { [prev, next].forEach(function (b) { if (b) b.style.display = 'none'; }); }
    show(0);
  }

  /* ---------- complete the look: hotspots + connector lines ---------- */
  function drawLines(slide) {
    var svg = slide.querySelector('[data-lines]');
    if (!svg) return;
    svg.innerHTML = '';
    if (window.matchMedia('(max-width: 1099px)').matches) return;
    var box = slide.getBoundingClientRect();
    if (!box.width) return;
    svg.setAttribute('viewBox', '0 0 ' + box.width + ' ' + box.height);
    $$('[data-hot]', slide).forEach(function (h) {
      var i = h.getAttribute('data-hot');
      var dot = slide.querySelector('[data-dot-for="' + i + '"]');
      if (!dot) return;
      var a = h.getBoundingClientRect(), b = dot.getBoundingClientRect();
      var x1 = a.left + a.width / 2 - box.left, y1 = a.top + a.height / 2 - box.top;
      var x2 = b.left + b.width / 2 - box.left, y2 = b.top + b.height / 2 - box.top;
      var dx = x2 - x1;
      var ex = x1 + (dx >= 0 ? 1 : -1) * Math.min(96, Math.abs(dx) * 0.38);
      var ns = 'http://www.w3.org/2000/svg';
      var p = document.createElementNS(ns, 'path');
      p.setAttribute('d', 'M' + x1 + ' ' + y1 + ' L' + ex + ' ' + y2 + ' L' + x2 + ' ' + y2);
      p.setAttribute('fill', 'none'); p.setAttribute('stroke', '#1f1d24'); p.setAttribute('stroke-width', '1.3');
      svg.appendChild(p);
    });
  }
  function initLooks(root) {
    if (root.__fgl) return; root.__fgl = true;
    function setOn(slide, i) {
      $$('[data-hot]', slide).forEach(function (h) { h.classList.toggle('is-on', h.getAttribute('data-hot') === i); });
      $$('[data-row]', slide).forEach(function (r) { r.classList.toggle('is-on', r.getAttribute('data-row') === i); });
    }
    $$('[data-slide]', root).forEach(function (slide) {
      $$('[data-hot]', slide).forEach(function (h) {
        var i = h.getAttribute('data-hot');
        h.addEventListener('mouseenter', function () { setOn(slide, i); });
        h.addEventListener('click', function () {
          setOn(slide, i);
          var r = slide.querySelector('[data-row="' + i + '"]');
          if (r && window.matchMedia('(max-width: 1099px)').matches) r.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
      $$('[data-row]', slide).forEach(function (r) {
        r.addEventListener('mouseenter', function () { setOn(slide, r.getAttribute('data-row')); });
      });
    });
    function redraw() { var s = root.querySelector('[data-slide].is-active'); if (s) drawLines(s); }
    root.addEventListener('fg:slide', function () { window.requestAnimationFrame(redraw); });
    window.addEventListener('resize', redraw);
    window.addEventListener('load', redraw);
    setTimeout(redraw, 300); setTimeout(redraw, 1200);
  }

  /* ---------- explore list ---------- */
  function initExplore(root) {
    if (root.__fge) return; root.__fge = true;
    var rows = $$('[data-row]', root), panels = $$('[data-panel]', root);
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    function set(i) {
      rows.forEach(function (r, j) { r.classList.toggle('is-active', j === i); });
      panels.forEach(function (p, j) { p.classList.toggle('is-active', j === i); });
    }
    rows.forEach(function (r, i) {
      r.addEventListener('mouseenter', function () { if (canHover) set(i); });
      r.addEventListener('focus', function () { set(i); });
      r.addEventListener('click', function (e) {
        if (!canHover && !r.classList.contains('is-active')) { e.preventDefault(); set(i); }
      });
    });
    set(0);
  }

  function boot(scope) {
    $$('[data-fg-carousel]', scope).forEach(initCarousel);
    $$('[data-fg-focus]', scope).forEach(initFocus);
    // looks must attach their listener BEFORE initSlides fires its first event
    $$('[data-fg-looks]', scope).forEach(initLooks);
    $$('[data-fg-slides]', scope).forEach(initSlides);
    $$('[data-fg-explore]', scope).forEach(initExplore);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();